module.exports = __webpack_public_path__ + "static/lightbulb-407f8e155aed4e6f8e8883c5dd4462de.png";